module.exports = __webpack_public_path__ + "img/33600.efa8ad82.jpg";